import rebuildToggleList from './rebuildToggleList';

/**
 * Init common pages content
 */
const initCommonPage = () => {
  const element = document.getElementById('CommonPage');
  if (!element) return;

  const pageName = element.getAttribute('data-page');
  const siteId = element.getAttribute('data-site-id');
  const policies = element.getAttribute('data-policies');
  const policyId = element.getAttribute('data-policy-id');

  let widgetOptions = {
    siteId,
    pageName,
  };

  if (policies && policyId) {
    widgetOptions = { ...widgetOptions, policies, policyId };
  }

  window.commonPagesWidget.widget(element, widgetOptions);

  window.addEventListener('contentRendered', () => {
    if (element.querySelector('.toggle-list')) rebuildToggleList();
  });
};

export default initCommonPage;
